
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      verif_info: 'getCrmVerificationFillingInfo'
    }),
    status() {
      let item = this.participant?.verificationStatus || this.item?.revisionStatus
      return this.verif_info.verificationStatuses?.find(el => el.verificationStatusId == item)
    },
    decision_status() {
      let item = this.participant?.verificationDecision || this.item?.decisionType
      return this.verif_info.decisionTypes?.find(el => el.decisionTypeId == item)
    }
  },
}
